module.exports = __webpack_public_path__ + "static/media/sertifikat.7d50948e.png";